import Repository from "../../repository";

export default {
    Add: (payload) => Repository.post(`/api/GuestContacts/Add`, payload),
    AddNoLogin: (payload) => Repository.post(`/api/GuestContacts/AddNoLogin`, payload),
}
